/** Fiksna lijeva navigacija, 224px, grupisana Danas / Promet / Zaliha / Podešavanja
 *  (DR-1A), svaka stavka sa linijskom ikonicom od 16px. Stavke koje još nisu napravljene
 *  stoje onemogućene, sa razlogom u naslovu — lakše je vidjeti dokle je stiglo nego da
 *  ih nema. */

import { IkonaNav } from './IkonaNav'

export type Ekran = 'katalog' | 'korisnici' | 'prijem'

const NAPRAVLJENI: string[] = ['katalog', 'korisnici', 'prijem']

const grupe: { naziv: string; stavke: { kljuc: string; oznaka: string }[] }[] = [
  { naziv: 'Danas', stavke: [{ kljuc: 'danas', oznaka: 'Danas' }] },
  {
    naziv: 'Promet',
    stavke: [
      { kljuc: 'prijem', oznaka: 'Prijem' },
      { kljuc: 'otpremnice', oznaka: 'Otpremnice' },
    ],
  },
  {
    naziv: 'Zaliha',
    stavke: [
      { kljuc: 'katalog', oznaka: 'Katalog' },
      { kljuc: 'lager', oznaka: 'Lager lista' },
      { kljuc: 'popis', oznaka: 'Popis' },
    ],
  },
  {
    naziv: 'Podešavanja',
    stavke: [
      { kljuc: 'partneri', oznaka: 'Partneri' },
      { kljuc: 'korisnici', oznaka: 'Korisnici' },
    ],
  },
]

export function Navigacija({
  aktivno,
  naIzbor,
}: {
  aktivno: Ekran
  naIzbor: (ekran: Ekran) => void
}) {
  return (
    <nav className="navigacija" aria-label="Glavna navigacija">
      <div className="navigacija__marka">
        <span className="naslov">bookbee</span>
      </div>
      {grupe.map((grupa) => (
        <div key={grupa.naziv}>
          <div className="navigacija__grupa oznaka">{grupa.naziv}</div>
          {grupa.stavke.map((stavka) => {
            const jeAktivna = stavka.kljuc === aktivno
            const radi = NAPRAVLJENI.includes(stavka.kljuc)
            return (
              <button
                key={stavka.kljuc}
                type="button"
                className={`navigacija__veza${jeAktivna ? ' navigacija__veza--aktivna' : ''}`}
                data-testid={`nav-${stavka.kljuc}`}
                aria-current={jeAktivna ? 'page' : undefined}
                disabled={!radi}
                title={radi ? undefined : 'Još nije napravljeno'}
                onClick={() => radi && naIzbor(stavka.kljuc as Ekran)}
              >
                <IkonaNav kljuc={stavka.kljuc} />
                {stavka.oznaka}
              </button>
            )
          })}
        </div>
      ))}
    </nav>
  )
}
